// extracted by mini-css-extract-plugin
module.exports = {"editorTitle":"editors_editorTitle__3OY4Q","editorContainer":"editors_editorContainer__3UDFy"};